import React from 'react';
import PropTypes from 'prop-types';
import ReadOnlyField from '../ReadOnlyField';

const OTHER_VALUE = '__OTHER__';

const AdvisorInfoReadOnly = ({
  formData,
  consortiumOptions,
  agencyOptions,
  subAgencyOptions,
  claimData,
  onEdit,
  children
}) => (
  <>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5 mb-8">
      <ReadOnlyField
        label="Consortium"
        value={
          formData.consortium === OTHER_VALUE
            ? formData.otherConsortiumName
            : consortiumOptions.find(o => o.value === formData.consortium)?.label
              || claimData?.consortium_name
        }
      />
      <ReadOnlyField
        label="Primary/Host Agency"
        value={
          formData.agency === OTHER_VALUE
            ? formData.otherAgencyName
            : agencyOptions.find(o => o.value === formData.agency)?.label
              || claimData?.agency_name
        }
      />
      <ReadOnlyField
        label="Branch/Agency"
        value={
          formData.subAgency === OTHER_VALUE
            ? formData.otherSubAgencyName
            : subAgencyOptions.find(o => o.value === formData.subAgency)?.label
              || claimData?.sub_agency_name
        }
      />
    </div>
    {children}
    <button
      type="button"
      onClick={onEdit}
      data-testid="ta-edit-button"
      className="text-[14px] font-semibold leading-[18px]
        text-black bg-transparent border border-gray-300
        rounded-lg px-6 py-3 cursor-pointer
        hover:bg-gray-50 transition-colors"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      Edit information
    </button>
  </>
);

AdvisorInfoReadOnly.propTypes = {
  formData: PropTypes.object.isRequired,
  consortiumOptions: PropTypes.array.isRequired,
  agencyOptions: PropTypes.array.isRequired,
  subAgencyOptions: PropTypes.array.isRequired,
  claimData: PropTypes.object,
  onEdit: PropTypes.func.isRequired
};

export default AdvisorInfoReadOnly;
